/**
 * Storing the current access property options
 */
const PositionAccessTypes = {
	F: "Full",
	E: "Edit",
	R: "Read-Only",
	N: "None",
};

export default PositionAccessTypes;
